import React, { useRef, useState, useEffect } from 'react';
import './style.css';
import { ReactComponent as PlayIcon } from '../../../../../../../../../assets/main/test/play.svg';
import { ReactComponent as PauseIcon } from '../../../../../../../../../assets/main/test/pause.svg';


interface AudioPlayerProps {
    audioUrl: string | undefined;
}

export const TestAudio: React.FC<AudioPlayerProps> = ({ audioUrl }) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);



    const formatTime = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);

        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };


    // Reset component state when src changes
    useEffect(() => {
        setIsPlaying(false);
        setProgress(0);
        setDuration(0);
        setCurrentTime(0);
    }, [audioUrl]);


    const togglePlayback = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleTimeUpdate = () => {
        const currentTimeValue = audioRef.current?.currentTime || 0;
        const totalDuration = audioRef.current?.duration || 0;
        const calculatedProgress = (currentTimeValue / totalDuration) * 100;

        setProgress(calculatedProgress);
        setCurrentTime(currentTimeValue);
    };
    const handleSeek = (e: React.MouseEvent<HTMLDivElement>) => {
        if (audioRef.current) {
            const seekTime = (e.nativeEvent.offsetX / e.currentTarget.offsetWidth) * audioRef.current.duration;
            audioRef.current.currentTime = seekTime;
        }
    };

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.addEventListener('timeupdate', handleTimeUpdate);
            audioRef.current.addEventListener('ended', () => setIsPlaying(false));
            return () => {
                audioRef.current?.removeEventListener('timeupdate', handleTimeUpdate);
                audioRef.current?.removeEventListener('ended', () => setIsPlaying(false));
            };
        }
    }, [audioUrl]); // Include src in the dependency array

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.addEventListener('loadedmetadata', () => {
                setDuration(audioRef.current?.duration || 0);
            });
            return () => {
                audioRef.current?.removeEventListener('loadedmetadata', () => {
                    setDuration(audioRef.current?.duration || 0);
                });
            };
        }
    }, [audioUrl]); // Include src in the dependency array

    const playerBarPlayedStyle = {
        width: `${progress}%`,
        background: isPlaying ? 'linear-gradient(90deg, #AFEF68 26.56%, #9BF2B4 100%)' : undefined,
    };

    return (
        <div className="audio-box">
            <div className="ppq-audio-player">
                <audio className="audio-player" preload="auto" ref={audioRef} src={audioUrl} />
                <div className="play-pause-btn">
                    <a style={{ boxShadow: "none" }} href="javascript: void(0);" className="play-pause-icon" onClick={togglePlayback}>
                        {isPlaying ? <PauseIcon /> : <PlayIcon />}
                    </a>
                </div>
                <div className="player-bar" onClick={handleSeek}>
                    <div className="player-bar-loaded"></div>
                    <div className="player-bar-played" style={playerBarPlayedStyle}></div>
                </div>
                <div className="player-time-box">
                    <div className="player-time player-time-current">{formatTime(currentTime)}</div>
                    <span className="separator">/</span>
                    <div className="player-time player-time-duration">{formatTime(duration)}</div>
                </div>
            </div>
        </div>
    );
};




// <div className="audio-box">
//     <audio controls ref={audioRef} src={src}/>
// </div>